import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth, isStaffUser } from "@/context/AuthContext";

const EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "click"];

export default function IdleTimeout() {
  const { user, signOut } = useAuth();
  const nav = useNavigate();
  const timer = useRef(null);
  const minutes = useRef(20);

  useEffect(() => {
    if (!user) return undefined;
    let mounted = true;
    const reset = () => {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        signOut();
        toast.info("You were signed out automatically after inactivity");
        nav(isStaffUser(user) ? "/admin" : "/login");
      }, minutes.current * 60000);
    };
    EVENTS.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();
    api.get("/auth/session-config")
      .then((r) => { if (mounted) { minutes.current = Number(r.data.session_timeout_minutes) || 20; reset(); } })
      .catch(() => {});
    return () => {
      mounted = false;
      clearTimeout(timer.current);
      EVENTS.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
